export const SERVICE_MESSAGE = {
  REPORT_SUCCESS: "Report received.\nWe will review and act within 24 hours.",
};

export const ERROR_MESSAGE = {
  GENERAL: "Failed.", // TODO: general error
  SERVER_ERROR: "Failed due to server error.",
};
